import { FC, useRef } from 'react';

import { Text, TooltipHover } from '@hh.ru/magritte-ui';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import styles from 'components/Admin/AdfoxInfo/TapTargetSelect/HintIcon/HintIcon.module.less';

interface HintIconProps {
    text: string;
    dataQa: string;
}

export const HintIcon: FC<HintIconProps> = ({ text, dataQa }) => {
    const activatorRef = useRef<HTMLSpanElement>(null);

    return (
        <>
            <span className={styles.hintIcon} ref={activatorRef} data-qa={dataQa}>
                <QuestionCircleOutlinedSize16 initialColor="secondary" />
            </span>
            <TooltipHover activatorRef={activatorRef} placement="right-center">
                <Text>{text}</Text>
            </TooltipHover>
        </>
    );
};
